import { render, staticRenderFns } from "./LandingLayout.vue?vue&type=template&id=361ca692&scoped=true"
import script from "./LandingLayout.vue?vue&type=script&lang=js"
export * from "./LandingLayout.vue?vue&type=script&lang=js"
import style0 from "./LandingLayout.vue?vue&type=style&index=0&id=361ca692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361ca692",
  null
  
)

export default component.exports